import { b as __awaiter, e as __generator, _ as __makeTemplateObject, f as __read, d as __assign } from '../../chunks/chunk-525a49bc.js';
import { Icon } from 'antd';
import React, { useState, useCallback, useMemo, useContext, useEffect } from 'react';
import styled from 'styled-components';
import '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import '../../chunks/chunk-6cec2b98.js';
import { w as withDefaultTheme } from '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';
import 'lodash';
import { C as Component } from '../../chunks/chunk-8a66acb9.js';
import 'uuid';
import { C as ClientSDKContext } from '../../chunks/chunk-645d2150.js';
import flatten from 'lodash/flatten';
import groupBy from 'lodash/groupBy';

var SearchItemResourceType;
(function (SearchItemResourceType) {
    SearchItemResourceType["Asset"] = "assets";
    SearchItemResourceType["Event"] = "events";
    SearchItemResourceType["Timeseries"] = "timeseries";
    SearchItemResourceType["File"] = "files";
})(SearchItemResourceType || (SearchItemResourceType = {}));

function withDiscriminator(l, resourceType) {
    return l.map(function (resource) { return ({ resource: resource, resourceType: resourceType }); });
}
var globalSearch = function (client, query, _a, limitPerItem) {
    var assets = _a.assets, timeseries = _a.timeseries, events = _a.events, files = _a.files;
    return __awaiter(void 0, void 0, void 0, function () {
        var searchForAssets, searchForTimeSeries, searchForEvents, searchForFiles, result;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    searchForAssets = function (filter) { return __awaiter(void 0, void 0, void 0, function () {
                        var items;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!filter) {
                                        return [2 /*return*/, []];
                                    }
                                    return [4 /*yield*/, client.assets.search({
                                            search: {
                                                query: query,
                                            },
                                            filter: filter,
                                            limit: limitPerItem,
                                        })];
                                case 1:
                                    items = _a.sent();
                                    return [2 /*return*/, withDiscriminator(items, SearchItemResourceType.Asset)];
                            }
                        });
                    }); };
                    searchForTimeSeries = function (filter) { return __awaiter(void 0, void 0, void 0, function () {
                        var items;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!filter) {
                                        return [2 /*return*/, []];
                                    }
                                    return [4 /*yield*/, client.timeseries.search({
                                            search: {
                                                query: query,
                                            },
                                            filter: filter,
                                            limit: limitPerItem,
                                        })];
                                case 1:
                                    items = _a.sent();
                                    return [2 /*return*/, withDiscriminator(items, SearchItemResourceType.Timeseries)];
                            }
                        });
                    }); };
                    searchForEvents = function (filter) { return __awaiter(void 0, void 0, void 0, function () {
                        var items;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!filter) {
                                        return [2 /*return*/, []];
                                    }
                                    return [4 /*yield*/, client.events.search({
                                            search: {
                                                description: query,
                                            },
                                            filter: filter,
                                            limit: limitPerItem,
                                        })];
                                case 1:
                                    items = _a.sent();
                                    return [2 /*return*/, withDiscriminator(items, SearchItemResourceType.Event)];
                            }
                        });
                    }); };
                    searchForFiles = function (filter) { return __awaiter(void 0, void 0, void 0, function () {
                        var items;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!filter) {
                                        return [2 /*return*/, []];
                                    }
                                    return [4 /*yield*/, client.files.search({
                                            search: {
                                                name: query,
                                            },
                                            filter: filter,
                                            limit: limitPerItem,
                                        })];
                                case 1:
                                    items = _a.sent();
                                    return [2 /*return*/, withDiscriminator(items, SearchItemResourceType.File)];
                            }
                        });
                    }); };
                    return [4 /*yield*/, Promise.all([
                            searchForAssets(assets),
                            searchForTimeSeries(timeseries),
                            searchForEvents(events),
                            searchForFiles(files),
                        ])];
                case 1:
                    result = _b.sent();
                    return [2 /*return*/, flatten(result)];
            }
        });
    });
};

function SearchResultList(_a) {
    var strings = _a.strings, items = _a.items, renderSearchItem = _a.renderSearchItem, onItemSelected = _a.onItemSelected, onItemHover = _a.onItemHover;
    var _b = __read(useState(10), 2), numItemsToShow = _b[0], setNumItemsToShow = _b[1];
    var handleSeeMoreClicked = useCallback(function () {
        setNumItemsToShow(numItemsToShow + 10);
    }, [numItemsToShow]);
    if (items.length == 0) {
        return (React.createElement(SearchResultListContainer, null,
            React.createElement("li", null,
                React.createElement("i", null, strings.emptySearch))));
    }
    var hasMoreItems = numItemsToShow < items.length;
    return (React.createElement(SearchResultListContainer, null,
        items.slice(0, numItemsToShow).map(function (item) { return (React.createElement(SearchResultItem, { key: item.resource.id, onClick: function () { return onItemSelected(item); }, onMouseOver: function () { return onItemHover(item); } }, renderSearchItem(strings, item))); }),
        hasMoreItems ? (React.createElement("a", { onClick: handleSeeMoreClicked, style: { display: 'inline-block', marginTop: '8px' } }, "See More")) : null));
}
var SearchResultListContainer = withDefaultTheme(styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  padding-left: 0px;\n"], ["\n  list-style: none;\n  padding-left: 0px;\n"]))));
var SearchResultItem = withDefaultTheme(styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gearbox.selectColor;
}));
var templateObject_1, templateObject_2;

var RefCounter = /** @class */ (function () {
    function RefCounter() {
        this.id = 0;
    }
    RefCounter.prototype.currentId = function () {
        return this.id;
    };
    RefCounter.prototype.nextId = function () {
        return ++this.id;
    };
    return RefCounter;
}());
var defaultStrings = {
    assets: 'Assets',
    timeSeries: 'Time Series',
    events: 'Events',
    files: 'Files',
    noDescription: '[No Description]',
    emptySearch: 'Nothing found',
    searchPlaceholder: 'Search for a resource',
};
function titleFromResource(strings, item) {
    switch (item.resourceType) {
        case SearchItemResourceType.Asset:
        case SearchItemResourceType.Timeseries:
        case SearchItemResourceType.File:
            return item.resource.name;
        case SearchItemResourceType.Event:
            return item.resource.description || strings.noDescription;
        default:
            return 'N/A';
    }
}
function iconFromResource(item) {
    switch (item.resourceType) {
        case SearchItemResourceType.Asset:
            return React.createElement(Icon, { type: "deployment-unit" });
        case SearchItemResourceType.Timeseries:
            return React.createElement(Icon, { type: "line-chart" });
        case SearchItemResourceType.Event:
            return React.createElement(Icon, { type: "alert" });
        case SearchItemResourceType.File:
            return React.createElement(Icon, { type: "file" });
    }
}
function defaultRenderSearchItem(strings, item) {
    var title = titleFromResource(strings, item);
    var icon = iconFromResource(item);
    return (React.createElement("div", { style: { padding: '4px 0px' } },
        React.createElement("span", { style: { marginRight: '6px' } }, icon),
        title));
}
function defaultRenderSearchResult(_a) {
    var strings = _a.strings, isLoading = _a.isLoading, searchForFilter = _a.searchForFilter, onItemSelected = _a.onItemSelected, onItemHover = _a.onItemHover, items = _a.items, renderSearchItem = _a.renderSearchItem;
    var itemsGroupedByResourceType = groupBy(items, function (item) { return item.resourceType; });
    var renderList = function (title, items) {
        var inner = isLoading && !items.length ? (React.createElement("i", null, "Searching...")) : (React.createElement(SearchResultList, { strings: strings, onItemSelected: onItemSelected, onItemHover: onItemHover, items: items, renderSearchItem: renderSearchItem }));
        return (React.createElement("div", { key: title },
            React.createElement(ResourceSectionHeader, null, title.toUpperCase()),
            inner));
    };
    return (React.createElement(React.Fragment, null, Object.keys(searchForFilter)
        .filter(function (key) { return itemsGroupedByResourceType[key]; })
        .map(function (key) {
        return renderList(strings[key], itemsGroupedByResourceType[key]);
    })));
}
function GlobalSearch(_a) {
    var _this = this;
    var userStrings = _a.strings, userSearchForFilter = _a.searchForFilter, onError = _a.onError, userRenderSearchResult = _a.renderSearchResult, userRenderSearchItem = _a.renderSearchItem, userOnItemSelected = _a.onItemSelected, onSearchResults = _a.onSearchResults, userOnItemHover = _a.onItemHover;
    var _b = __read(useState(), 2), searchResults = _b[0], setSearchResultsState = _b[1];
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var _d = __read(useState(new RefCounter()), 1), searchCounter = _d[0];
    var _e = __read(useState(), 2), searchQuery = _e[0], setSearchQuery = _e[1];
    var searchForFilter = useMemo(function () {
        return !userSearchForFilter
            ? {
                assets: {},
                events: {},
                timeSeries: {},
                files: {},
            }
            : userSearchForFilter;
    }, [userSearchForFilter]);
    var client = useContext(ClientSDKContext);
    var strings = __assign(__assign({}, defaultStrings), (userStrings || {}));
    var renderSearchResult = userRenderSearchResult || defaultRenderSearchResult;
    var renderSearchItem = userRenderSearchItem || defaultRenderSearchItem;
    var onItemSelected = function (item) {
        if (userOnItemSelected) {
            userOnItemSelected(item);
        }
    };
    var onItemHover = function (item) {
        if (userOnItemHover) {
            userOnItemHover(item);
        }
    };
    useEffect(function () {
        if (onSearchResults && searchResults) {
            onSearchResults(searchResults);
        }
    }, [searchResults]);
    var handleSearch = function (searchQuery) {
        setSearchQuery(searchQuery);
    };
    var setSearchResults = function (items) {
        setSearchResultsState(items);
        setLoading(false);
    };
    var search = function (searchId, client, query, filters, limitPerItem) {
        if (limitPerItem === void 0) { limitPerItem = 50; }
        return __awaiter(_this, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, globalSearch(client, query, filters, limitPerItem)];
                    case 1:
                        result = _a.sent();
                        if (searchId === searchCounter.currentId()) {
                            setSearchResults(result);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        if (searchId === searchCounter.currentId()) {
                            if (onError) {
                                onError(e_1);
                            }
                            setSearchResults([]);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        if (!searchQuery) {
            return;
        }
        if (client === null) {
            throw new Error('Remember to add a ClientSDKProvider before using any Gearbox components.');
        }
        if (!searchQuery.query) {
            setSearchResults([]);
            return;
        }
        setLoading(true);
        // The searchCounter prevents old search results from replacing newer search results
        var thisId = searchCounter.nextId();
        search(thisId, client, searchQuery.query, searchForFilter);
    }, [client, searchCounter, searchQuery, searchForFilter]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Component, { loading: loading, strings: strings, onSearch: handleSearch }),
        searchResults &&
            !!searchResults.length &&
            renderSearchResult({
                strings: strings,
                isLoading: loading,
                searchForFilter: searchForFilter,
                onItemSelected: onItemSelected,
                onItemHover: onItemHover,
                items: searchResults,
                renderSearchItem: renderSearchItem,
            })));
}
var ResourceSectionHeader = withDefaultTheme(styled.h2(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  font-weight: 600;\n  margin-top: 8px;\n"], ["\n  font-weight: 600;\n  margin-top: 8px;\n"]))));
var templateObject_1$1;

export { GlobalSearch, globalSearch };
